<template>
<div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">
  <div style="margin-left: 70px">
    <el-button v-if="this.parentData" type="success" :loading="loading" @click="deleteChartData">{{"数据修复"}}</el-button>
    <el-button type="primary">{{"物件选择"}}</el-button>
    <el-select v-model="wuJianId" @change="renderAllEcharts" clearable placeholder="物件名称" style="width: 200px;">
      <el-option
          v-for="item in wuJianNames"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>

  <el-row style="height: 50%;">
    <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
      <div class="title">
        <span>{{'组立不良推移-物件别'}}</span>
      </div>
      <div style="height: 95%;width: 100%" v-loading="wuJianChartLoading" element-loading-text="数据加载中" id="wuJianZuLi"/>
    </el-col>
    <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
      <div class="title">
        <span>{{'组立日不良推移'}}</span>
        <div class="space-between">
          <el-date-picker v-model="dayBad.dateDay" @change="getDayChart" :clearable="false" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 110px" size="small"/>
        </div>
      </div>
      <div class="chart_size" v-loading="dayChartLoading" element-loading-text="数据加载中" id="dayZuLi"/>
    </el-col>
  </el-row>

  <el-row style="height: 50%;">
    <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
      <div class="title">
        <span>{{'组立单元不良数量/面积'}}</span>
        <div class="space-between">
          <el-date-picker v-model="unitNum.year" @change="getNumChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
          <el-date-picker v-model="unitNum.month" @change="getNumChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
        </div>
      </div>
      <div class="chart_size" v-loading="numChartLoading" element-loading-text="数据加载中" id="zuLiNum"/>
    </el-col>
    <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
      <div class="title">
        {{'次工程不良推移-物件别'}}
        <div class="space-between">
          <el-date-picker v-model="drumDate.year" @change="getDrumChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
          <el-date-picker v-model="drumDate.month" @change="getDrumChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          <!--              <el-date-picker v-model="drumDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
        </div>
      </div>
      <div class="chart_size" v-loading="drumChartLoading" element-loading-text="数据加载中" id="drumZuLi"/>
    </el-col>
  </el-row>

  <el-row style="height: 50%;">
    <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
      <div class="title">{{'组立直行率-物件'}}</div>
      <div style="height: 95%;width: 100%" v-loading="zhixingChartLoading" element-loading-text="数据加载中" id="wuJianZhiXing"/>
    </el-col>
    <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
      <div class="title">
        {{'组立单元不良项/面积'}}
        <div class="space-between">
          <el-date-picker v-model="unitItem.year" @change="getItemChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
          <el-date-picker v-model="unitItem.month" @change="getItemChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
        </div>
      </div>
      <div class="chart_size" v-loading="itemChartLoading" element-loading-text="数据加载中" id="zuLiItem"/>
    </el-col>
  </el-row>

  <KfDialog v-model="dialogVisible" :item="dialogItem">

    <template #footer>
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
        <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
          <span style="font-size: 24px;">{{this.chartData.name}}</span>
          <el-input-number v-model="this.chartData.value"/>
        </div>
        <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
      </div>
    </template>
  </KfDialog>

</div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ZuLiBuLiangPage",
  props: ['parentData'],
  data(){
    return{
      maxHeight:'',
      dialogVisible:false,
      loading:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      wuJianId:'',
      wuJianNames:[],
      unitNum:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        table:'bus_zuli_zhijian_record'
      },
      unitItem:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        table:'bus_zuli_check_item_record'
      },
      /*物件别玻璃不良推移*/
      wujianQuery:{},
      optionWuJian: {
        type:'wujian_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          /*{
            name: '二次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },*/
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [
            ]
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ],
        dataZoom:[
          {
            start: 0,
            end: 100,
            type: 'slider',
            show: true,
            // xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            startValue: null, // 初始显示值
            endValue: null, // 结束显示值
            height: 15,//组件高度
            left: '5%', //左边的距离
            right: '4%',//右边的距离
            borderRadius: 5,
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: true,//即拖拽时候是否显示详细数值信息 默认true
            realtime: false, //是否实时更新
            filterMode: 'filter',
          },
          //下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            // xAxisIndex: [0],
            start: 1,//默认为1
            end: 100,//默认为100
          },
        ]
      },
      wuJianChartLoading:false,
      /*日不良率*/
      dayBad:{
        dateDay:this.getDateFormat(),
      },
      dayChartLoading:false,
      optionDayBad: {
        type:'day_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '日不良数量',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '日不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },

        ]
      },
      dayBadLoading:false,
      /*数量不良推移*/
      optionNum: {
        type:'buliang_num',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良单元数量',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '数量/面积',
            min:0,
            max:15,
            interval:3,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(2)
              }
            }
          },
        ],
        series: [
          {
            name: '不良单元数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '不良单元数量/面积',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            yAxisIndex: 1,
            data: [
            ]
          },
        ]
      },
      numChartLoading:false,
      /*不良项推移*/
      optionItem: {
        type:'buliang_item',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单元不良项数量',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良项/面积',
            min:0,
            max:15,
            interval:3,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(2)
              }
            }
          },
        ],
        series: [
          {
            name: '单元不良项数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '单元不良项/面积',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            yAxisIndex: 1,
            data: [
            ]
          },
        ]
      },
      itemChartLoading:false,
      /*组立不良堆积图*/
      optionDrum: {
        type:'drum_chart',
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = `${params[0].name} <br/>`
            for (const item of params) {
              if (item.value !== 0) {
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',            // 设置图例翻页
          orient: 'horizontal',     // 图例横向排布
          data: [],              // title是一个列表，存着图例的数据
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [2109, 2110, 2111, 2112, 2201, 2202, 2203]
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            max: function (value) {
              return value.max + 20;
            }
          }
        ],
        series: [
          {
            name: '无应力',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: '擦伤,划伤',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '二次胶不良',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '膜不良',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '内脏',
            type: 'bar',
            data: [862, 1018, 964, 1026, 1679, 1600, 1570],
            emphasis: {
              focus: 'series'
            },
            markLine: {
              lineStyle: {
                type: 'dashed'
              },
              data: [[{ type: 'min' }, { type: 'max' }]]
            }
          },
          {
            name: '氩气不足',
            type: 'bar',
            barWidth: 5,
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [60, 73, 71, 74, 100, 130, 120]
          },
          {
            name: 'PVB不良',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 290, 230, 220]
          },
          {
            name: '开裂',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [60, 72, 71, 74, 190, 130, 110]
          },
          {
            name: '叠差',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '变形',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '结石',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '爆边,爆角',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '实物与标签不符',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '表面凹坑',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          }
        ]
      },
      drumChartLoading:false,
      drumDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        /*day:''*/
      },
      /*直行率不良推移*/
      zhixingQuery:{},
      optionZhixing: {
        type:"wujian_chart",
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单元总数',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 95,
            max: 100,
            interval: 1,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '完成品数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [
            ]
          },
          {
            name: '直行率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ],
        dataZoom:[
          {
            start: 0,
            end: 100,//默认为100
            type: 'slider',
            show: true,
            // xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            startValue: null, // 初始显示值
            endValue: null, // 结束显示值
            height: 15,//组件高度
            left: '5%', //左边的距离
            right: '4%',//右边的距离
            borderRadius: 5,
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: true,//即拖拽时候是否显示详细数值信息 默认true
            realtime: false, //是否实时更新
            filterMode: 'filter',
          },
          //下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            // xAxisIndex: [0],
            start: 1,//默认为1
            end: 100,//默认为100
          },
        ]
      },
      zhixingChartLoading:false,
    }
  },
  methods:{
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this
        if (this.parentData) {
          chart.on('click', function (params) {
            _this.dialogVisible = true
            _this.dialogItem.title = params.seriesName
            _this.chartData.seriesName = params.seriesName
            _this.chartData.value = params.value
            _this.chartData.name = params.name
            _this.chartData.dataIndex = params.dataIndex
            _this.chartData.seriesIndex = params.seriesIndex
            _this.chartData.chartType = option.type
          })
        }
      }
    },

    renderAllEcharts(){
      this.getWuJianChart()
      this.getDayChart()
      this.getNumChart()
      this.getItemChart()
      this.getDrumChart()
      this.getZhixingChart()
    },

    async deleteChartData(){
      this.loading = true
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_zulibuliang_page");
      let {data: res1} = await this.$axios.post('bus/homePage/deleteChartData',"bus_zulizhixing_page");
      if (res.code !== 0 || res1.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
      this.loading = false
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "buliang_num":
          this.unitNum.wujian_id = this.wuJianId
            this.unitNum.field = this.unitNum.table
          this.chartData.query = this.unitNum
          break
        case "buliang_item":
          this.unitItem.wujian_id = this.wuJianId
          this.unitItem.field = this.unitItem.table
          this.chartData.query = this.unitItem
          break
      }
      this.chartData.model = "bus_zulibuliang_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "buliang_num":
         await this.getNumChart()
          break
        case "buliang_item":
          await this.getItemChart()
          break
      }

    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getDayChart() {
        this.dayChartLoading = true
        this.dayBad.wujian_id = this.wuJianId
        let {data: res} = await this.$axios.post('bus/zuLiZhiJian/dayChart', this.dayBad);
        if (res.code !== 0) {
          this.$message.error(res.message)
        }
        if (res.data.XDay) {
          this.optionDayBad.xAxis[0].data = res.data.XDay
          this.optionDayBad.series[0].data = res.data.badNum
          let a = this.$common.getDivisor(Math.max(...res.data.badNum))
          this.optionDayBad.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
          this.optionDayBad.yAxis[0].interval = Math.round(this.optionDayBad.yAxis[0].max/5*100)/100
          //this.optionDayBad.series[1].data = res.data.badPercent
        }
        this.renderEcharts('dayZuLi', this.optionDayBad)

        this.dayChartLoading = false
    },

    async getWuJianChart() {
      this.wuJianChartLoading = true
      let query = {
        wuJianId:this.wuJianId,
        start:this.optionWuJian.dataZoom[0].startValue,
        end:this.optionWuJian.dataZoom[0].endValue,
      }
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/wuJianChart',query);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.optionWuJian.series[0].data = null
        this.optionWuJian.series[2].data = null
        this.wuJianChartLoading = false
      }else {
        if (res.data) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.series[0].data
          /*this.optionWuJian.series[1].data = res.data.badNumTwo*/
          // for (let i = 0; i < this.optionWuJian.xAxis[0].data.length; i++) {
          //   this.optionWuJian.series[1].data.push(this.wuJianTarget)
          // }
          if (res.data.targets) {
            this.optionWuJian.series[1].data = res.data.targets
          }
          this.optionWuJian.series[2].data = res.data.series[1].data
          let a = this.$common.getDivisor(Math.max(...res.data.series[0].data))
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.series[0].data)/a)*a
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max/5*100)/100
          /*this.optionWuJian.yAxis[1].max = Math.max(...res.data.badPercent) > this.wuJianTarget ? Math.max(...res.data.badPercent) : this.wuJianTarget
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max/5*100)/100*/
          this.optionWuJian.dataZoom[0].startValue = (this.optionWuJian.xAxis[0].data.length - 4) > 0 ? (this.optionWuJian.xAxis[0].data.length - 4) : 0
          this.optionWuJian.dataZoom[0].endValue = this.optionWuJian.xAxis[0].data.length
        }
      }
      this.renderEcharts('wuJianZuLi',this.optionWuJian)

      this.wuJianChartLoading = false
    },

    async getNumChart() {
      this.numChartLoading = true
      if (!this.unitNum.year){
        this.unitNum.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.unitNum.chart_type = this.optionNum.type
      this.unitNum.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiBuLiang/zuLiChart',this.unitNum);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        if (res.data.XDay) {
          this.optionNum.xAxis[0].data = res.data.XDay
          this.optionNum.series[0].data = res.data.series
          this.optionNum.series[1].data = res.data.seriesLine
          let a = this.$common.getDivisor(Math.max(...res.data.series))
          this.optionNum.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
          this.optionNum.yAxis[0].interval = Math.round(this.optionNum.yAxis[0].max/5*100)/100
          this.optionNum.yAxis[1].max = Math.ceil(Math.max(...res.data.seriesLine))
          this.optionNum.yAxis[1].interval = Math.round(this.optionNum.yAxis[1].max/5*100)/100
        }
      }
      this.renderEcharts('zuLiNum',this.optionNum)

      this.numChartLoading = false
    },

    async getItemChart() {
      this.itemChartLoading = true
      if (!this.unitItem.year){
        this.unitItem.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.unitItem.chart_type = this.optionItem.type
      this.unitItem.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiBuLiang/zuLiChart',this.unitItem);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        if (res.data.XDay) {
          this.optionItem.xAxis[0].data = res.data.XDay
          this.optionItem.series[0].data = res.data.series
          this.optionItem.series[1].data = res.data.seriesLine
          let a = this.$common.getDivisor(Math.max(...res.data.series))
          this.optionItem.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
          this.optionItem.yAxis[0].interval = Math.round(this.optionItem.yAxis[0].max/5*100)/100
          this.optionItem.yAxis[1].max = Math.ceil(Math.max(...res.data.seriesLine))
          this.optionItem.yAxis[1].interval = Math.round(this.optionItem.yAxis[1].max/5*100)/100
        }
      }
      this.renderEcharts('zuLiItem',this.optionItem)

      this.itemChartLoading = false
    },

    async getDrumChart() {
      if (!this.drumDate.year){
        this.drumDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.drumChartLoading = true
      this.drumDate.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/drumChart',this.drumDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionDrum.xAxis[0].data = res.data.XDay
        this.optionDrum.series = res.data.drumSeries
        this.optionDrum.legend.data = res.data.drumSeries
        this.renderEcharts('drumZuLi', this.optionDrum)
      }

      this.drumChartLoading = false
    },

    async getZhixingChart() {
      this.zhixingChartLoading = true
      this.zhixingQuery.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/zhiXingChart',this.zhixingQuery);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.optionZhixing.series[0].data = null
        this.optionZhixing.series[1].data = null
        this.zhixingChartLoading = false
      }else {
        if (res.data.XMonth) {
          this.optionZhixing.xAxis[0].data = res.data.XMonth
          this.optionZhixing.series[0].data = res.data.series[0].data
          this.optionZhixing.series[1].data = res.data.series[1].data
          if (res.data.targets) {
            this.optionZhixing.series[2].data = res.data.targets
          }
          this.optionZhixing.series[3].data = res.data.series[2].data
          this.optionZhixing.yAxis[0].max = Math.ceil(Math.max(...res.data.series[0].data,...res.data.series[1].data)/100)*100
          this.optionZhixing.yAxis[0].interval = Math.round(this.optionZhixing.yAxis[0].max / 5 * 100) / 100
          /*this.optionZhixing.yAxis[1].max = Math.max(...res.data.series[2].data)
          this.optionZhixing.yAxis[1].interval = Math.round(this.optionZhixing.yAxis[1].max / 5 * 100) / 100*/
          this.optionZhixing.dataZoom[0].start = Math.max((this.optionZhixing.xAxis[0].data.length - 4),0) * 100 / this.optionZhixing.xAxis[0].data.length
          this.optionZhixing.dataZoom[0].end = 100
        }
      }
      this.renderEcharts('wuJianZhiXing',this.optionZhixing)

      this.zhixingChartLoading = false
    },

  },

  created() {
    this.getMaxHeight()
    this.getWuJianInFo()
  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  justify-content: space-around;
  width: 100%;
}
.size{
  width: 100%;
  height: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}
.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}
.chart_size{
  width: 100%;
  height: 90%
}

.asideContainer {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
</style>